import L from "leaflet";
import bluePinPng from "../assets/marker-icon.png";
import bluePin2xPng from "../assets/marker-icon-2x.png";
import markerShadowPng from "../assets/marker-shadow.png";

/** The single basemap source for every map in the app. Import these rather than
 *  hardcoding a tile URL, so swapping providers stays a one-file change.
 *
 *  History of this endpoint, so nobody re-walks it:
 *   - basemaps.cartocdn.com: watermarks unauthenticated requests, being retired
 *     by CARTO. Do not reintroduce.
 *   - {s}.tile.openstreetmap.org: OSM blocked us off their volunteer servers
 *     (tiles came back as an "Access Blocked" image, osm.wiki/Blocked). The
 *     block is server-side, so no URL/referrer tweak brings it back.
 *   - Esri ArcGIS World_Street_Map (current): keyless, no signup, attribution
 *     required. No usage guarantee for commercial volume, hence the override
 *     below.
 *
 *  To move to a keyed provider (MapTiler, Stadia, ...) set REACT_APP_MAP_TILE_URL
 *  and REACT_APP_MAP_TILE_ATTRIBUTION at build time — e.g. in package.json next
 *  to REACT_APP_CONFIG — and no map component needs to change. CRA inlines
 *  REACT_APP_* at build time, so these are baked per build, not read at runtime.
 */
const ESRI_STREET_URL =
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
const ESRI_STREET_ATTRIBUTION =
    'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, DeLorme, NAVTEQ, USGS';

export const MAP_TILE_URL = process.env.REACT_APP_MAP_TILE_URL || ESRI_STREET_URL;
export const MAP_TILE_ATTRIBUTION =
    process.env.REACT_APP_MAP_TILE_ATTRIBUTION || ESRI_STREET_ATTRIBUTION;

/** World_Street_Map tops out at z19; keep every map on the same ceiling so a
 *  provider swap only has to match one number. */
export const MAP_TILE_MAX_ZOOM = 19;

const bluePinIcon = L.icon({
    iconUrl: bluePinPng,
    iconRetinaUrl: bluePin2xPng,
    shadowUrl: markerShadowPng,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});

/** Match GpsMapModal: default marker uses bundled blue pin assets. */
export function ensureProjectMapMarkerIcon(): void {
    L.Marker.prototype.options.icon = bluePinIcon;
}

export { bluePinIcon };
